import { TableConfig } from '../../../components/table/Table';

export const initUsermanagementTableConfig = (): TableConfig => {
  return [
    {
      id: 1,
      columnName: 'Name',
      attributName: 'name',
      valueType: 'string',
    },
    {
      id: 2,
      columnName: 'E-Mail',
      attributName: 'email',
      valueType: 'string',
    },
    {
      id: 3,
      columnName: 'Matchcode',
      attributName: 'matchcode',
      valueType: 'string',
    },
    {
      id: 4,
      columnName: 'Adresse',
      attributName: 'adressenname',
      valueType: 'string',
    },
    {
      id: 5,
      columnName: 'Straße',
      attributName: 'strasse',
      valueType: 'string',
    },
    {
      id: 6,
      columnName: 'PLZ',
      attributName: 'plz',
      valueType: 'string',
    },
    {
      id: 7,
      columnName: 'Ort',
      attributName: 'ort',
      valueType: 'string',
    },
    {
      id: 8,
      columnName: 'Erstellt am',
      attributName: 'erstelltAm',
      valueType: 'string',
    },
    {
      id: 9,
      columnName: 'Aktualisiert am',
      attributName: 'aktualisiertAm',
      valueType: 'string',
    },
  ];
};
